import React from 'react';
import { ProviderBrandAvatar } from 'src/modules/shared/components/molecules/provider-brand-avatar';
import type { IntegrationView } from 'src/modules/settings/schemas/integrations.schema';

interface IntegrationBrandAvatarProps {
  integrationId: IntegrationView;
}

/**
 * Renders the branded integration avatar used across the integrations index and
 * detail pages.
 */
export const IntegrationBrandAvatar: React.FC<IntegrationBrandAvatarProps> = ({
  integrationId,
}) => <ProviderBrandAvatar providerId={integrationId} size="md" />;
